export default __webpack_public_path__ + "static/ready-illustration-64ad8d1b6e4cc4d91ce4d9929d086162.png";